import React, { ReactNode } from "react";
import HPButton from "./Button";

interface BaseModalProps {
  title: string | ReactNode;
  children?: ReactNode;
  message?: string | ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  confirmButtonIcon?: ReactNode;
  headerIcon?: ReactNode;
  loading?: boolean;
  confirmDisabled?: boolean;
  containerClassName?: string;
}

const BaseModal: React.FC<BaseModalProps> = ({
  title,
  message,
  children,
  cancelButtonText,
  confirmButtonText,
  onCancel,
  onConfirm,
  confirmButtonIcon,
  headerIcon,
  loading,
  confirmDisabled,
  containerClassName,
}) => {
  return (
    <div
      className={`bg-white w-full rounded-lg  shadow-lg flex flex-col max-w-fit  mx-auto ${headerIcon ? " min-w-[540px]" : ""} ${containerClassName || ""}`}
    >
      <div className="p-6 flex gap-1">
        {headerIcon} <h2 className="text-lg font-semibold">{title}</h2>
      </div>

      <div className="text-sm border-t border-b border-hp-border-default">
        <div className="p-6 flex flex-col gap-2">
          {message && <p>{message}</p>}
          <div>{children}</div>
        </div>
      </div>

      <div className="  flex justify-end gap-1 p-4">
        {cancelButtonText && (
          <HPButton
            ariaLabel="Import Survey"
            variant="text"
            size="medium"
            color="primary"
            onClick={onCancel}
            className="text-hp-text-day-primary"
          >
            {cancelButtonText}
          </HPButton>
        )}

        {confirmButtonText && (
          <HPButton
            disabled={loading || confirmDisabled}
            startIcon={confirmButtonIcon}
            ariaLabel="Import Survey"
            variant="contained"
            size="medium"
            onClick={onConfirm}
          >
            {confirmButtonText}
          </HPButton>
        )}
      </div>
    </div>
  );
};

export default BaseModal;
